import React from 'react';
import { METRIC_COLORS, METRIC_LABELS } from '../utils/chartUtils';

function MetricsFilters({ visibleMetrics, toggleMetric }) {
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 640;
  
  const metricKeys = ['avg', 'p50', 'p85', 'p95'];
  
  return (
    <div className="flex flex-col items-center gap-3 mb-4">
      <h4 className="text-sm font-semibold text-gray-700">Filtrar Métricas:</h4>
      <div className="flex flex-wrap justify-center gap-2">
        {metricKeys.map(key => (
          <button
            key={key}
            onClick={() => toggleMetric(key)}
            className={`px-3 py-1 rounded-full border transition-all ${isMobile ? 'text-xs' : 'text-sm'} font-medium ${visibleMetrics[key] ? '' : 'bg-gray-200 text-gray-600 hover:bg-gray-300'}`}
            style={visibleMetrics[key] ? {
              backgroundColor: METRIC_COLORS[key],
              color: '#fff', 
              fontWeight: 700,
              borderColor: METRIC_COLORS[key]
            } : {
              borderColor: '#d1d5db'
            }}
          >
            {METRIC_LABELS[key]}
          </button>
        ))}
      </div>
    </div>
  );
}

export default MetricsFilters;
